export default "/images/ic-whatsapp-card.svg?dc4b3a38d1e392f0f56923e19944fba7";